import React, { FC, useEffect, useState } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { getRandomStr, momentFormat } from "@/utils/utils";
import { ILplAuditDetail, lplService } from "@/views/ledger/processList/lplService";
import {EditableRow, EditableCell} from "@/components/YHEditTable/editTable";
import moment from "moment";
import {purchasesService} from "../../../purchasesService"
import { globalPrompt } from "@/components/message";
import useGlobalModel from "@/model/globalModel";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const [dataSource, setDataSource] = useState<ILplAuditDetail[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { isApproveEditable } = useGlobalModel(() => []);

    const loadData = async () => {
        setLoading(true);
        const searchParams = {
            codes: id,
            page: {
                pageSize: 1000,
                pageNum: 1,
            }
        };
        let { retData } = await lplService.auditPage(searchParams);
        const { records, ...pg } = retData;
        setDataSource((records ?? []).map(item => ({ 
            ...item, 
            key: getRandomStr(),
            createTime:item.createTime   ? moment(item.createTime)  : null,
            updateTime:item.updateTime   ? moment(item.updateTime)  : null 
         })));
        setLoading(false);
    }

    useEffect(() => {
        loadData()
    }, [])

    const columns = [
        {
            title: '序号',
            width: 40,
            align: "center",
            fixed: "left",
            render: (t:any, r:any, i:any) => i + 1
        }, {
            title: '审批级别',
            width: 160,
            dataIndex: 'auditLevel',
        }, {
            title: '提交人',
            width: 120,
            dataIndex: 'submitUser',
        },
        // {
        //     title: '待审人',
        //     width: 120,
        //     dataIndex: 'auditUser',
        // },
        {
            title: '审批人',
            width: 120,
            dataIndex: 'auditUser',
        }, {
            title: '审批意见',
            width: 160,
            dataIndex: 'status',
            render: (text: any) => typeof text === "number" ? text ? "驳回" : "同意" : ""
        },  {
            title: '审批说明',
            width: 160,
            dataIndex: 'note',
        }, {
            title: '申请时间',
            width: 160,
            dataIndex: 'createTime',
            render: (v: any) => momentFormat(v as string, "YYYY-MM-DD"),
            editable:isApproveEditable,
            editType:'datepicker'
        }, {
            title: '审批时间',
            width: 160,
            dataIndex: 'updateTime',
            render: (v: any) => momentFormat(v as string, "YYYY-MM-DD"),
            editable:isApproveEditable,
            editType:'datepicker'
        }
    ];

    const newColumn = columns.map((col:any,index)=>{
        return{
            ...col,
            onCell:(record:ILplAuditDetail,rowIndex:number)=>({
                colIndex: index,
                rowIndex,
                record,
                //rules: col.rules,
                options:col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave, 
            }),
        }
    })

    const handleSave =(row: ILplAuditDetail)=>{
        let data:ILplAuditDetail[] = [...dataSource];
        const index = data.findIndex((item)=>row.id ===item.id )
        const item = data[index]
        data.splice(index,1,{...item,...row}) 
        setDataSource(data)
        if(row.createTime !==moment(momentFormat(row.createTime as string, "YYYY-MM-DDTHH:mm:ss"))){
         let data = {
             id:row.id,
             createTime:momentFormat(row.createTime as string, "YYYY-MM-DDTHH:mm:ss"),
             updateTime:momentFormat(row.updateTime as string, "YYYY-MM-DDTHH:mm:ss")
         }
         purchasesService.offerTime(data).then(()=>{
             globalPrompt('message',{text:"修改成功",type:"success"})
         })
         
     
        }else{
         if(row.updateTime!==moment(momentFormat(row.updateTime as string, "YYYY-MM-DDTHH:mm:ss"))){
             let data = {
                 id:row.id,
                 updateTime:momentFormat(row.updateTime as string, "YYYY-MM-DDTHH:mm:ss")
             }
             purchasesService.offerTime(data).then(()=>{
                 globalPrompt('message',{text:"修改成功",type:"success"})
             })
            }else{
             console.error()
            }
        
        }

    }


    return (
        <YhBox title="审批明细" style={{ marginBottom: "75px" }}>
            <Table
                loading={loading}
                columns={newColumn as  ColumnsType<ILplAuditDetail>}
                dataSource={dataSource}
                pagination={false}
                scroll={{ x: 'max-content' }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
            />
        </YhBox>
    )
}